export default __webpack_public_path__ + "static/media/dino_showroom_280rxt.3d234f3e.jpg";